<script>
  export let fullWidth;
  // Classes that apply to the full width of the page. Use this to add background colors
  export let fullWidthClasses = "";
  // Styles that apply to the full width of the page
  export let fullWidthStyles = "";
  // Classes that apply to the content area of the Bleed. Use this to add horizontal padding
  export let contentClasses = "";
</script>

<div class:w-full={fullWidth} {...$$restProps}>
  <div
    style="{fullWidth
      ? `width: 100vw !important;
      margin-left: calc(50% - 50vw);`
      : ``} {fullWidthStyles}"
    class={fullWidthClasses}
  >
    <!-- Content area -->
    <div class="max-w-screen-lg mx-auto {contentClasses}">
      <slot />
    </div>
  </div>
</div>
